import { prepareVersionSelectTitle } from 'components/common/TreeProgramFilter/VersionSelect/versionSelect.utils';

export const VersionListItem = ({ version, onClick }) => {
    return (
        <div onClick={() => onClick(version)} key={version.id}>
            {prepareVersionSelectTitle(version)}
        </div>
    );
};
